import { createFileRoute } from '@tanstack/react-router';

import { Button, ButtonGroup } from '@/common/components/button';
import { Checkbox, CheckboxField } from '@/common/components/checkbox';
import { DescriptionDetails, DescriptionList, DescriptionTerm } from '@/common/components/description-list';
import { Field, FieldRow, Fieldset, Label, Legend } from '@/common/components/fieldset';
import { Heading } from '@/common/components/heading';
import { Input } from '@/common/components/input';
import { Select } from '@/common/components/select';
import { Text } from '@/common/components/text';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/common/components/tooltip';
import { PenIcon } from '@/icons/fa/regular';

export const Route = createFileRoute(
  '/applications/$application-id/identity-check/'
)({
  component: IdentityCheckComponent
});

function IdentityCheckComponent() {
  const handleNameChange = () => {
  };

  return (
    <div className="p-8">
      <Heading>Identity Check</Heading>

      <DescriptionList>
        <DescriptionTerm>Full Legal Name</DescriptionTerm>
        <DescriptionDetails>
          <div className="flex flex-row gap-2 items-center">
            <div>Steven Benitez</div>
            <div>
              <Tooltip>
                <TooltipTrigger asChild>
                  <Button plain onClick={handleNameChange}>
                    <PenIcon/>
                  </Button>
                </TooltipTrigger>
                <TooltipContent>
                  Update Name
                </TooltipContent>
              </Tooltip>
            </div>
          </div>
        </DescriptionDetails>

        <DescriptionTerm>Contact Information</DescriptionTerm>
        <DescriptionDetails>
          (666) 777-8888<br/>
          steven@slashpine.tech
        </DescriptionDetails>

        <DescriptionTerm>Mailing Address</DescriptionTerm>
        <DescriptionDetails>
          914 Railroad Ave.<br/>
          Ste 2<br/>
          Tallahassee, FL 32310
        </DescriptionDetails>
      </DescriptionList>

      <Fieldset>
        <Legend>Personal Identification</Legend>

        <FieldRow cols={2}>
          <Field>
            <Label>Social Security Number</Label>
            <Input name="ssn" />
          </Field>

          <Field>
            <Label>Date of Birth</Label>
            <Input type="date" name="dob" />
          </Field>
        </FieldRow>

        <FieldRow cols={2}>
          <Field>
            <Label>Driver's License Number</Label>
            <Input name="dlNumber" placeholder="X123-456-78-900-0" />
          </Field>

          <Field>
            <Label>Driver's License State</Label>
            <Select name="state">
              <option value="FL">Florida</option>
            </Select>
          </Field>
        </FieldRow>

        <FieldRow cols={2}>
          <Field>
            <Label>Phone Number</Label>
            <Input name="phone" />
          </Field>
        </FieldRow>

        <CheckboxField>
          <Checkbox name="phoneType" value="mobile" />
          <Label>This phone number is a mobile phone and can receive texts.</Label>
        </CheckboxField>

        <Text>
          This application process includes verification of a One-Time Password ("OTP") via a text to the phone number you provided. Please read the following Disclosure and indicate your authorization to continue.
        </Text>

        <Text>
          You authorize us to use the phone number provided to verify your identity, which may include disclosing the phone number provided to a third-party to send you a One-Time Password via SMS text message. If a One-Time Password is sent, mobile messaging rates may apply. You authorize your wireless operator to disclose to us your account, subscriber, device and billing information if available, to support verification of your identity. Where applicable, this information may also be shared by us with other companies to support your transactions and for fraud avoidance purposes.
        </Text>

        <CheckboxField>
          <Checkbox name="agree" value="yes" />
          <Label>I have read and agree to the <strong>OTP Disclosure</strong> above.</Label>
        </CheckboxField>
      </Fieldset>

      <ButtonGroup>
        <Button to="/applications/$application-id/identity-check/verify-code" params={{ 'application-id': '1' }}>Next</Button>
      </ButtonGroup>
    </div>
  );
}
